<template>
    <div class="landing-page-wrapper">
        <div class="landing-info-wrapper">
            <component :is="getClientType === 'particular' ? BaiLogo : BaiEmpresaLogo"/>
            <div class="landing-message">{{ t('landingPageMessage') }}</div>
            <div class="buttons-wrapper">
                <div class="button"
                @click="appleHandler">
                    <apple-store-icon/>
                </div>
                <div class="button"
                @click="googleHandler">
                    <google-store-icon/>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import BaiLogo from '@/assets/images/logo-bai-particular-light-color.svg?inline'
import BaiEmpresaLogo from '@/assets/images/logo-bai-company-light-color.svg?inline'
import AppleStoreIcon from '@/assets/images/apple-store-icon.svg?inline'
import GoogleStoreIcon from '@/assets/images/google-store-icon.svg?inline'

/* Store */
import { mapGetters } from '@/store/helpers/mappers'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

const { getClientType } = mapGetters()

const appleHandler = () => {
    const store = getClientType.value === 'particular' ? 'https://apps.apple.com/pt/app/baidirecto-particular/id6472233886' : 'https://apps.apple.com/pt/app/baidirecto-empresa/id6479080857'

    window.open(store, '_blank')
}

const googleHandler = () => {
    const store = getClientType.value === 'particular' ? 'https://play.google.com/store/apps/details?id=ao.bai.baidirecto.beta' : 'https://play.google.com/store/apps/details?id=ao.bai.baidirecto.corporate&hl=en&gl=US'

    window.open(store, '_blank')
}
</script>

<style lang="scss" scoped>
.landing-page-wrapper {
    width: 100%;
    height: 100%;

    background-color: #FFFFFF;

    display: flex;
    align-items: center;
    justify-content: center;

    .landing-info-wrapper {
        width: 331px;

        padding: 24px;

        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 24px;

        .landing-message {
            @include H6-Regular;
            line-height: 18px;
            color: #242526;

            text-align: center;
        }

        .buttons-wrapper {
            width: 100%;

            display: flex;
            flex-direction: row;
            gap: 8px;

            .button {
                width: calc(50% - 4px);
                height: 40px;

                display: flex;
                align-items: center;
                justify-content: center;

                border-radius: 8px;
                background-color: #242526;
                cursor: pointer;
            }
        }
    }
}
</style>
